<template>
	<div class="con">
		<div class="discuss" v-if="list.length > 0">
			<div v-for="(item, index) in list" :key='index' class="discuss-disp" >
				<img class="discuss-img" src="../assets/charUser.png">
				<div class="discuss-rignt">
					<div class="wecha-name">{{item.wechaName}}</div>
					<div class="create-time">{{item.createDate}}</div>
					<div class="xing-list">
						<div v-for="(it,cell) in item.evalue" :key="cell">
							<van-icon name="star" class="xingColor" size="20" />
						</div>
					</div>
					<div class="remarks-text">{{item.remarks}}</div>
				</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == false">
			<img src="../assets/404.gif"/>
			<div class="no-text">没有记录~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'docFeedback',
		data() {
			return {
				msg: '对我的反馈',
				emUserInfo: {},
				list: [],
				noImgShow: true,
			}
		},
		methods: {
			//查询对我的反馈
			GetFeedback() {
				this.$store.commit('Load', true)
				this.$Axios.Get('/collect/getProposal?tepy=1' + '&ysdm=' + this.emUserInfo.userId + '&page=' + 1 + '&limit=' + 30, null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if (res.code == 0) {
						let dataList = res.msg.list;
						if(dataList.length > 0){
							this.list = res.msg.list;
							this.noImgShow = true;
						}else{
							this.noImgShow = false;
						}
						
					}else{
						this.noImgShow = false;
					}

				}).catch(err => {
					this.$store.commit('Load', false)
					this.noImgShow = false;
					console.log(err)
				})
			},

		},
		mounted() {
			if (localStorage.getItem('emUserInfo') != undefined) {
				this.emUserInfo = JSON.parse(localStorage.getItem('emUserInfo'));
				this.GetFeedback()
			}
		}
	}
</script>

<style scoped>
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}
	.discuss{
		height: 50vh;
		overflow-y: scroll;
	}
	.discuss-disp{
		display: flex;
		padding: 5px 10px;
		margin: 5px 0;
		background-color: #fff;
	}
	.discuss-img{
		width: 40px;
		height: 40px;
	}
	.discuss-rignt{
		margin-left: 10px;
	}
	.wecha-name{
		font-weight: 700;
		font-size: 14px;
		color: #000000;
	}
	.create-time{
		color: #999;
		font-size: 12px;
	}
	.xing-list{
		display: flex;
	}
	.remarks-text{
		color: #666;
		font-size: 14px;
	}
	.xingColor {
		color: #F4EA2A;
	}
	.noImg{
		margin-top: 10vh;
		text-align: center;
	}
	.no-text{
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
		
	}
</style>
